import React, { useState } from 'react';
import { Container, Typography, Button, Box, Avatar } from '@mui/material';

const About = () => {
  const [showMore, setShowMore] = useState(false);

  const handleToggle = () => {
    setShowMore(!showMore);
  };

  return (
    <Container
      sx={{
        mt: 4,
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        color: '#515669',
        gap: 4,
      }}
    >
      {/* Left Side: Text Content */}
      <Box sx={{ maxWidth: { xs: '100%', md: '50%' } }}>
        {/* Main Title */}
        <Typography
          variant="h4"
          sx={{ fontWeight: 'bold', mb: 2, fontSize: { xs: '1.8rem', md: '2.5rem' } }}
        >
          About Me
        </Typography>

        {/* Subtitle */}
        <Typography
          variant="h5"
          sx={{ fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2, color: '#6E7A90' }}
        >
          Frontend Developer
        </Typography>

        {/* Small About Content */}
        <Typography
          variant="body1"
          sx={{
            color: '#6E7A90',
            mb: 2,
            fontSize: { xs: '0.9rem', md: '1rem' },
            maxWidth: '600px',
          }}
        >
          I am a passionate developer with experience in building responsive and user-friendly web
          applications. My focus is on delivering high-quality solutions to complex problems.
        </Typography>

        {/* See More Button */}
        {!showMore && (
          <Button
            variant="contained"
            sx={{
              mb: 2,
              backgroundColor: '#6E7A90',
              color: '#FFFFFF',
              '&:hover': { backgroundColor: '#8893A7' },
            }}
            onClick={handleToggle}
          >
            See More
          </Button>
        )}

        {/* Expanded Content */}
        {showMore && (
          <>
            <Typography
              variant="body1"
              sx={{
                color: '#6E7A90',
                mb: 2,
                fontSize: { xs: '0.9rem', md: '1rem' },
                maxWidth: '600px',
              }}
            >
              I specialize in modern web technologies like React, Material-UI, and responsive design. My
              passion lies in creating intuitive interfaces and ensuring seamless user experiences.
            </Typography>
            <Button
              variant="contained"
              sx={{
                mb: 2,
                backgroundColor: '#6E7A90',
                color: '#FFFFFF',
                '&:hover': { backgroundColor: '#8893A7' },
              }}
              onClick={handleToggle}
            >
              Show Less
            </Button>
          </>
        )}

        {/* Contact Information */}
        <Box>
          <Typography
            variant="body2"
            sx={{ fontSize: '1rem', color: '#6E7A90', mt: 3 }}
          >
            Email: <strong>www.beaconbin2004@gmail.com</strong>
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontSize: '1rem', color: '#6E7A90', mt: 1 }}
          >
            Mobile: <strong>9043527400</strong>
          </Typography>
        </Box>
      </Box>

      {/* Right Side: Image */}
      <Box
        sx={{
          maxWidth: { xs: '100%', md: '45%' },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Avatar
          variant="rounded"
          src={`${process.env.PUBLIC_URL}/About.png`}
          alt="My Photo"
          sx={{
            width: { xs: 200, md: 300 }, // Adjusted width for smaller size
            height: { xs: 300, md: 350 }, // Adjusted height for smaller size
            borderRadius: '8px', // Slightly rounded corners
            boxShadow: '10px 10px 25px rgba(0, 0, 0, 0.3)',
            objectFit: 'fill', // Ensures the image fits within the container
          }}
        />
      </Box>
    </Container>
  );
};

export default About;
